export default __webpack_public_path__ + "static/media/computers2.9f3dcf6a.png";